import React from 'react';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import HeaderColumn from './HeaderColumn';

const TableHeader = ({
    headerColumns,
    sortedBy,
    sortDir,
    sortByField,
    selectable = true,
    isLoading,
}) => {
    return (
        <TableHead>
            <TableRow>
                {selectable && <HeaderColumn padding='checkbox' />}
                {headerColumns.map(headerColumn => {
                    const isSorted =
                        sortedBy === headerColumn.sortableProps?.sortKey;
                    return (
                        <HeaderColumn
                            isSorted={isSorted}
                            sortDir={sortDir}
                            key={headerColumn.labelText}
                            sortByField={sortByField}
                            isLoading={isLoading}
                            {...headerColumn}
                        />
                    );
                })}
            </TableRow>
        </TableHead>
    );
};

export default TableHeader;
